export default __webpack_public_path__ + "5305e09e8f2e7e0ef7384c2261fff62b91989eb62e99fd7e878ca94c9103d9af.png";